import M from "../../../strings";
import {alert} from "../../../plugins";
import {TextCell, TextCellWithSubText} from "../grids";
import {
    AreaNoCard,
    Button,
    Column,
    DateTime,
    MultiLineText,
    Number, OnlyTextInfo,
    ReadOnlyText,
    ReadOnlyTextArea,
    Select,
    Spacer,
    Switch,
    Text,
    TextArea,
    YesNo
} from "../forms";
import {ValuesLookupContainer, ValuesSelectContainer} from "../containers";
import {
    AssignationType,
    CompanyCustomType,
    CustomerType,
    DocumentStatus,
    DossierStatus,
    DossierStatusDatasource,
    getCustomerTypeDescription,
    getDossierStatusPosition,
    getKPMGStatusDescription,
    KPMGStatusDatasource,
    WORK_COMPLETION_DOCUMENTS_CODE,
    QUOTATION_TYPES_ONLY_BLIND,
    getBlindsPresentsValueDescription,
    BlindsPresentsValues,
    DOSSIER_TYPE,
    QUOTATION_TYPES_BONUSCASA_2022_2_ONLY_BLIND,
    QUOTATION_TYPES_BONUSCASA_2022_2_ONLY_SUPPLY
} from "../../../model/vars";
import * as datasource from "../../../utils/datasource";
import {StatusCell} from "../customDossierGrids";
import {DossierStore} from "../../../stores/dossier";
import {updateFormData} from "../../../actions/entities";
import _ from "underscore";
import {isDifferent, optional, parseBoolean} from "../../../utils/lang";
import {isSuperuser} from "../../../api/session";
import {DossierAddDocumentDialog} from "../dossiers/dossierAddDocumentDialog";
import {DossierRefuseDocumentDialog} from "../dossiers/dossierRefuseDocumentDialog";
import {KPMGSendForReview, restoreCanDownload} from "../../../actions/dossier";
import {DossierDocumentContainer} from "../dossiers/dossierDocumentContainer";
import moment from "moment";
import * as config from "../../../framework/config";
import {
    formatEuroNumber,
    formatNumber,
} from "../dossiers/utils";
import {valuesSelectContainerField} from "../../commonFields";
import {Dossier_2022_BonusCasa_2_Store} from "../../../stores/dossier_2022_2_bonusCasa";
import {generateQuotationAmounts_2022_BonusCasa_2} from "../../../actions/dossier_2022_2_bonusCasa";
import {Dossier_2022_bonusCasa_2_priceCalculatorControl} from "./dossier_2022_bonusCasa_2_priceCalculatorControl";
import {Dossier_2022_BonusCasa_2_FormFooter} from "./dossier_2022_bonusCasa_2_Form";

function quotationSurfaceSizeVisibility(model, withBlind = true) {

    let quotationType = model.get("quotationType")
    let climaticZone = model.get("climaticZone")
    let blindPresentType = model.get("blindsPresentsType")

    if (withBlind) {
        blindPresentType = blindPresentType && model.get("blindsPresentsType") !== BlindsPresentsValues.NO.value
    } else {
        blindPresentType = blindPresentType && model.get("blindsPresentsType") !== BlindsPresentsValues.YES.value
    }

    return quotationType && blindPresentType && climaticZone
}

function quotationFieldsVisibility(model, withBlind = true) {
    let surfaceSize
    if (withBlind) {
        surfaceSize = model.get("surfaceSize")
    }else {
        surfaceSize = model.get("surfaceSizeWithoutBlind")
    }
    return quotationSurfaceSizeVisibility(model, withBlind) && surfaceSize && surfaceSize > 0
}

export const dossier_2022_bonusCasa_2_Entity = {
    grid: {
        canDelete: () => {
            return false;
        },
        getTitle: (type) => {
            return M(type)
        },
        descriptor: {
            columns: [
                {
                    property: "dossierCode",
                    header: M("#"),
                    cell: TextCellWithSubText,
                    sortable: true,
                    searchable: true,
                    searchForm: {
                        searchTitle: M("filterByDate"),
                        showInCard: false,
                        fields: [
                            {
                                property: "_dateFrom",
                                label: M("from"),
                                control: Text,
                                filterType: "eq",
                            },
                            {
                                property: "_dateTo",
                                label: M("to"),
                                control: Text,
                                filterType: "eq",
                            }
                        ]
                    },
                    props: {
                        formatterTitle: (v) => {
                            return v != null ? v : "";
                        },
                        formatterSubtitle: (v, data) => {
                            return v != null ? moment(data.creationDate).format("DD/MM/YYYY") : "";
                        }
                    }
                },
                {
                    property: "customer",
                    header: M("customer"),
                    cell: TextCellWithSubText,
                    sortable: true,
                    searchable: true,
                    searchForm: {
                        showInCard: false,
                        fields: [
                            {
                                property: "customerId",
                                label: M("customer"),
                                control: ValuesSelectContainer,
                                filterType: "eq",
                                props: {
                                    id: "dossier_customer",
                                    mode: "single",
                                    allowNull: true,
                                    searchEnabled: true,
                                    collection: "customers",
                                    getSingleItemLabel: (value) => {
                                        return value.name
                                    },
                                    getSingleItemValue: (value) => {
                                        return value.id
                                    },
                                    formatter: v => {
                                        return v != null ? v.name : "";
                                    }
                                }
                            },
                        ]
                    },
                    props: {
                        formatterTitle: (v) => {
                            return v != null ? v.name : "";
                        },
                        formatterSubtitle: (v) => {
                            return v != null ? getCustomerTypeDescription(v.subjectType) : "";
                        }
                    }
                },
                {
                    property: "fabricator",
                    header: M("fabricator"),
                    cell: TextCellWithSubText,
                    sortable: true,
                    searchable: true,
                    searchForm: {
                        showInCard: false,
                        fields: [
                            {
                                property: "fabricatorId",
                                label: M("fabricator"),
                                control: ValuesSelectContainer,
                                filterType: "eq",
                                props: {
                                    id: "dossier_fabricator",
                                    mode: "single",
                                    allowNull: true,
                                    searchEnabled: true,
                                    collection: "fabricators",
                                    getSingleItemLabel: (value) => {
                                        return value.businessName
                                    },
                                    getSingleItemValue: (value) => {
                                        return value.id
                                    },
                                    formatter: v => {
                                        return v != null ? v.businessName : "";
                                    }
                                }
                            },
                            {
                                property: "fabricatorCategoryId",
                                label: M("referenceToUserCategory"),
                                control: ValuesSelectContainer,
                                filterType: "eq",
                                props: {
                                    id: "fabricator_category",
                                    mode: "single",
                                    allowNull: true,
                                    searchEnabled: true,
                                    collection: "fabricatorCategories",
                                    getSingleItemLabel: (value) => {
                                        return value.description
                                    },
                                    getSingleItemValue: (value) => {
                                        return value.id
                                    },
                                    formatter: v => {
                                        return v != null ? v.description : "";
                                    }
                                }
                            },
                        ]
                    },
                    props: {
                        formatterTitle: (v) => {
                            return v != null ? v.businessName : "";
                        },
                        formatterSubtitle: (v) => {
                            return v != null && v.category? v.category.description : "";
                        }
                    }
                },
                {
                    property: "recommendedPrice",
                    header: M("amount"),
                    cell: TextCell,
                    sortable: true,
                    searchable: false,

                    props: {
                        formatter: v => {

                            let value = v;
                            if (v && v.recommendedRetailPrice) {
                                value = v.recommendedRetailPrice
                            }
                            return formatEuroNumber(value)
                        }
                    }
                },
                {
                    property: "canBeCandidate",
                    header: M("canBeCandidate"),
                    cell: TextCell,
                    sortable: true,
                    searchable: true,
                    isVisible(data) {
                        return isSuperuser()
                    },
                    searchForm: {
                        showInCard: false,
                        fields: [
                            {
                                property: "canBeCandidate",
                                label: M("canBeCandidate"),
                                control: Select,
                                filterType: "eq",
                                props: {
                                    allowNull: true,
                                    datasource: datasource.fixed([
                                        {label: M("yes"), value: true},
                                        {label: M("no"), value: false},
                                    ]),
                                },
                            }
                        ]
                    },
                    props: {
                        formatter: v => {
                            return v != null && v ? M("yes") : M("no");
                        }
                    }
                },
                {
                    property: "candidateAE",
                    header: M("candidateAE"),
                    cell: TextCell,
                    sortable: true,
                    searchable: true,
                    isVisible(data) {
                        return isSuperuser()
                    },
                    searchForm: {
                        showInCard: false,
                        fields: [
                            {
                                property: "candidateAE",
                                label: M("candidateAE"),
                                control: Select,
                                filterType: "eq",
                                props: {
                                    allowNull: true,
                                    datasource: datasource.fixed([
                                        {label: M("yes"), value: true},
                                        {label: M("no"), value: false},
                                    ]),
                                },
                            }
                        ]
                    },
                    props: {
                        formatter: v => {
                            return v != null && v ? M("yes") : M("no");
                        }
                    }
                },
                {
                    property: "candidateENEA",
                    header: M("candidateENEA"),
                    cell: TextCell,
                    sortable: true,
                    isVisible(data) {
                        return isSuperuser()
                    },
                    searchable: true,
                    searchForm: {
                        showInCard: false,
                        fields: [
                            {
                                property: "candidateENEA",
                                label: M("candidateENEA"),
                                control: Select,
                                filterType: "eq",
                                props: {
                                    allowNull: true,
                                    datasource: datasource.fixed([
                                        {label: M("yes"), value: true},
                                        {label: M("no"), value: false},
                                    ]),
                                },
                            }
                        ]
                    },
                    props: {
                        formatter: v => {
                            return v != null && v ? M("yes") : M("no");
                        }
                    }
                },
                {
                    property: "serviceFeeInvoiced",
                    header: M("serviceFeeInvoiced"),
                    cell: TextCell,
                    sortable: true,
                    isVisible(data) {
                        return isSuperuser()
                    },
                    searchable: true,
                    searchForm: {
                        showInCard: false,
                        fields: [
                            {
                                property: "serviceFeeInvoiced",
                                label: M("serviceFeeInvoiced"),
                                control: Select,
                                filterType: "eq",
                                props: {
                                    allowNull: true,
                                    datasource: datasource.fixed([
                                        {label: M("yes"), value: true},
                                        {label: M("no"), value: false},
                                    ]),
                                },
                            }
                        ]
                    },
                    props: {
                        formatter: v => {
                            return v != null && v ? M("yes") : M("no");
                        }
                    }
                },
                {
                    property: "_province",
                    header: M("province"),
                    cell: TextCell,
                    sortable: true,
                    searchable: true,
                },
                {
                    property: "_region",
                    header: M("region"),
                    cell: TextCell,
                    sortable: true,
                    searchable: true,
                },
                {
                    property: "_preparatoryDocumentations",
                    header: M("preparatoryDocumentsShort"),
                    cell: TextCell,
                    sortable: true,
                    searchable: true,
                    searchForm: {
                        showInCard: false,
                        fields: [
                            {
                                property: "_filterType",
                                label: "Doc. propedeutica - Tipo filtro",
                                control: Select,
                                hide: true,
                                props: {
                                    allowNull: false,
                                    datasource: datasource.fixed([
                                        {label: M("equalsTo"), value: "eq"},
                                        {label: M("lowerThan"), value: "lt"},
                                        {label: M("greaterThan"), value: "gt"}
                                    ])
                                }
                            },
                            {
                                property: "_preparatoryDocumentations",
                                label: M("_preparatoryDocumentations"),
                                control: Number,
                            },


                            {
                                property: "_approvedDocuments_filterType",
                                label: M("_approvedDocuments_filterType"),
                                control: Select,
                                hide: true,
                                props: {
                                    allowNull: false,
                                    datasource: datasource.fixed([
                                        {label: M("equalsTo"), value: "eq"},
                                        {label: M("lowerThan"), value: "lt"},
                                        {label: M("greaterThan"), value: "gt"}
                                    ])
                                }
                            },

                            {
                                property: "_approvedDocumentationsNumber",
                                label: M("_approvedDocumentationsNumber"),
                                control: Number,
                            },

                            {
                                property: "_documentTypeSet",
                                label: M("documentType"),
                                control: ValuesSelectContainer,
                                filterType: "eq",
                                props: {
                                    id: "dossier_documentType",
                                    mode: "single",
                                    allowNull: true,
                                    searchEnabled: true,
                                    collection: "documentTypes?types=" + AssignationType.ENEA_PREPARATORY_DOCUMENTATION.value + ";" + AssignationType.PREPARATORY_DOCUMENTATION.value,
                                    getSingleItemLabel: (value) => {
                                        return value.fullDescription
                                    },
                                    getSingleItemValue: (value) => {
                                        return value.id
                                    },
                                    formatter: v => {
                                        return v != null ? v.fullDescription : "";
                                    }
                                }
                            },

                        ]
                    },
                },
                {
                    property: "_closingDocumentations",
                    header: M("closingDocumentsShort"),
                    cell: TextCell,
                    sortable: false,
                    searchable: true,
                    searchForm: {
                        showInCard: false,
                        fields: [
                            {
                                property: "_approvedClosingDocuments_filterType",
                                label: M("_uploadClosingDocuments_filterType"),
                                control: Select,
                                hide: true,
                                props: {
                                    allowNull: false,
                                    datasource: datasource.fixed([
                                        {label: M("equalsTo"), value: "eq"},
                                        {label: M("lowerThan"), value: "lt"},
                                        {label: M("greaterThan"), value: "gt"}
                                    ])
                                }
                            },
                            {
                                property: "_approvedDocumentationsClosingNumber",
                                label: M("_uploadDocumentationsClosingNumber"),
                                control: Number,
                            },
                            {
                                property: "_documentTypeClosingSet",
                                label: M("documentType"),
                                control: ValuesSelectContainer,
                                filterType: "eq",
                                props: {
                                    id: "dossier_closingDocumentType",
                                    mode: "single",
                                    allowNull: true,
                                    searchEnabled: true,
                                    getCollection: (model) =>{
                                        return "documentTypes?types=" + AssignationType.PUBLIC_CLOSING_DOCUMENTATION.value + ";" + AssignationType.PUBLIC_CLOSING_DOCUMENTATION.value;
                                    },
                                    getSingleItemLabel: (value) => {
                                        return value.fullDescription
                                    },
                                    getSingleItemValue: (value) => {
                                        return value.id
                                    },
                                    formatter: v => {
                                        return v != null ? v.fullDescription : "";
                                    }
                                }
                            },

                        ]
                    },
                },
                {
                    property: "workCompletionDate",
                    header: M("workCompletionDate"),
                    cell: TextCell,
                    sortable: true,
                    searchable: false,
                    props: {
                        formatter: v => {
                            return v != null ? moment(v).format("MM/DD/YYYY") : "-"
                        }
                    }
                },
                {
                    property: "kpmgstatus",
                    header: M("KPMGStatus"),
                    cell: TextCell,
                    sortable: false,
                    isVisible: () => isSuperuser(),
                    searchable: true,
                    props: {
                        formatter: v => {
                            return v != null ? getKPMGStatusDescription(v) : "-"
                        }
                    },
                    searchForm: {
                        showInCard: false,
                        fields: [
                            {
                                property: "KPMGStatus",
                                label: M("KPMGStatus"),
                                control: Select,
                                filterType: "eq",
                                props: {
                                    allowNull: true,
                                    datasource: KPMGStatusDatasource,
                                },
                            }
                        ]
                    },
                },
                {
                    property: "priority",
                    header: M("priority"),
                    cell: TextCell,
                    sortable: false,
                    isVisible(data) {
                        return isSuperuser()
                    },
                    searchable: true,
                    searchForm: {
                        showInCard: false,
                        fields: [
                            {
                                property: "priority",
                                label: M("priority"),
                                control: Select,
                                filterType: "eq",
                                props: {
                                    allowNull: true,
                                    datasource: datasource.fixed([
                                        {label: M("yes"), value: true},
                                        {label: M("no"), value: false},
                                    ]),
                                },
                            }
                        ]
                    },
                    props: {
                        formatter: v => {
                            return v != null && v ? M("yes") : M("no");
                        }
                    }
                },
                {
                    property: "status",
                    header: M("status"),
                    cell: StatusCell,
                    sortable: false,
                    searchable: true,
                    searchForm: {
                        showInCard: false,
                        fields: [
                            {
                                property: "status",
                                label: M("status"),
                                control: Select,
                                filterType: "eq",
                                props: {
                                    allowNull: true,
                                    datasource: DossierStatusDatasource,
                                },
                            }
                        ]
                    },
                },
            ]
        }
    },
    form: {
        title: M("dossierEcoBonus"),
        getActions(data) {
            return ["back", "save", "save-go-back", "revisions"];
        },
        stores: [
            {
                store: DossierStore,
                callback(model, state) {
                    if (state.dossier) {
                        updateFormData({
                            data: state.dossier,
                            discriminator: "entity_form_dossier"
                        })
                    }
                }
            }
        ],
        descriptor: {
            stores: [DossierStore, Dossier_2022_BonusCasa_2_Store],
            showFormFooter: false,
            formUpdateFunction: (newState, oldState, model) => {
                if (newState.canDownload && newState.downloadUrl != null) {
                    restoreCanDownload();
                    window.open(config.get("service.url") + newState.downloadUrl, "_blank");
                }

                if (newState && newState.completed) {
                    if (!_.isEmpty(newState.documents) && isDifferent(newState.documents, oldState.documents)) {
                        model.set("documents", newState.documents);
                        model.invalidateForm();
                    }
                }

                if (isDifferent(newState.priceCalculatorSheet, oldState.priceCalculatorSheet)) {
                    //Set: setto i nuovi valori
                    model.set("priceCalculatorSheet", newState.priceCalculatorSheet);

                    if (newState.priceCalculatorSheet.message != null && newState.priceCalculatorSheet.message.length > 0 && (oldState.priceCalculatorSheet == null || newState.priceCalculatorSheet.message !== oldState.priceCalculatorSheet.message)) {
                        Swal.fire({
                            title: M("warning"),
                            icon: 'error',
                            html: newState.priceCalculatorSheet.message,
                            showCloseButton: true,
                            focusConfirm: false,
                        })
                    }
                    model.invalidateForm();
                }
            },
            onModelLoadFirstTime: (model) => {
                model.on("property:change", (property, value) => {

                    switch (property) {
                        case "_fabricator":
                            model.set("_fabricatorCollaborator", null);
                            model.invalidateForm();
                            break;
                        case "estateTypeAndUse":
                        case "window":
                        case "blind":
                        case "otherWorks":
                        case "takenMeasures":
                        case "windowWithoutBlind":
                        case "blindWithoutBlind":
                        case "otherWorksWithoutBlind":
                        case "takenMeasuresWithoutBlind":
                        case "customer":
                        case "quotationType":
                        case "blindsPresentsType":
                        case "surfaceSize":
                        case "surfaceSizeWithoutBlind":
                        case "climaticZone":

                            let subjectType = "";
                            let customer = model.get("_customer");
                            if (customer != null) {
                                subjectType = customer.subjectType;
                            }

                            let estateTypeAndUse = model.get("estateTypeAndUse");
                            if (estateTypeAndUse == null) {
                                estateTypeAndUse = "";
                            }

                            let window = optional(model.get("window"), 0);
                            if (window === "" || window === "-")
                                window = 0;
                            let blind = optional(model.get("blind"), 0);
                            if (blind === "" || blind === "-")
                                blind = 0;
                            let otherWorks =optional( model.get("otherWorks"), 0);
                            if (otherWorks === "" || otherWorks === "-")
                                otherWorks = 0;
                            let takenMeasures = optional(model.get("takenMeasures"), 0);
                            if (takenMeasures === "" || takenMeasures === "-")
                                takenMeasures = 0;


                            let windowWithoutBlind = optional(model.get("windowWithoutBlind"), 0);
                            if (windowWithoutBlind === "" || windowWithoutBlind === "-")
                                windowWithoutBlind = 0;
                            let blindWithoutBlind = optional(model.get("blindWithoutBlind"), 0);
                            if (blindWithoutBlind === "" || blindWithoutBlind === "-")
                                blindWithoutBlind = 0;
                            let otherWorksWithoutBlind =optional( model.get("otherWorksWithoutBlind"), 0);
                            if (otherWorksWithoutBlind === "" || otherWorksWithoutBlind === "-")
                                otherWorksWithoutBlind = 0;
                            let takenMeasuresWithoutBlind = optional(model.get("takenMeasuresWithoutBlind"), 0);
                            if (takenMeasuresWithoutBlind === "" || takenMeasuresWithoutBlind === "-")
                                takenMeasuresWithoutBlind = 0;

                            if(property === "quotationType" && QUOTATION_TYPES_ONLY_BLIND.indexOf(model.get("quotationType")) !== -1) {
                                model.set("blindsPresentsType", BlindsPresentsValues.YES.value)
                            }

                            let quotationType = optional(model.get("quotationType"), "")
                            let blindsPresentsType = optional(model.get("blindsPresentsType"), "")

                            if (QUOTATION_TYPES_BONUSCASA_2022_2_ONLY_BLIND.indexOf(quotationType) !== -1) {
                                model.untrackChanges()
                                model.set("blindsPresentsType", BlindsPresentsValues.YES.value)
                                model.trackChanges()
                            }

                            let climaticZone = optional(model.get("climaticZone"), "")
                            let surfaceSize = optional(model.get("surfaceSize"), 0)
                            let surfaceSizeWithoutBlind = optional(model.get("surfaceSizeWithoutBlind"), 0)

                            if (surfaceSize === "" || surfaceSize === "-")
                                surfaceSize = 0;

                            if (surfaceSizeWithoutBlind === "" || surfaceSizeWithoutBlind === "-")
                                surfaceSizeWithoutBlind = 0;



                            let skipErrorsIfIncomplete = true;

                            model.propagateValidationException = false;
                            model.resetValidation()
                            model.validate()
                            let dossierCreationDate = model.get("creationDate") != null ? model.get("creationDate") : new Date().getTime();

                            generateQuotationAmounts_2022_BonusCasa_2({subjectType, estateTypeAndUse, window, blind, otherWorks, takenMeasures, windowWithoutBlind, blindWithoutBlind, otherWorksWithoutBlind, takenMeasuresWithoutBlind, dossierCreationDate, skipErrorsIfIncomplete, quotationType, blindsPresentsType, climaticZone, surfaceSize, surfaceSizeWithoutBlind});
                            model.propagateValidationException = true;
                            model.invalidateForm()
                            break;
                        case "_customer" :
                            if(model && model.data &&
                                model.data._customer &&
                                model.data._customer.subjectType == CustomerType.SUBJECT_TYPE_LEGAL_PERSON.value){
                                var companyCustomType = model.data._customer.companyCustomType;
                                if(_.isEmpty(companyCustomType)){
                                    alert("La tipologia azienda non è stata settata per il cliente " + model.data._customer.name + ". Si prega di andare nella sezione Cliente ed aggiornare la relativa anagrafica.");
                                    model.set("_customer", null);
                                    model.validate()
                                }else if(companyCustomType == CompanyCustomType.SPA.value || companyCustomType == CompanyCustomType.SAPA.value ||
                                    companyCustomType == CompanyCustomType.SRL.value || companyCustomType == CompanyCustomType.SRLS.value){
                                    alert("Il Bonus Casa non è applicabile alle persone giuridiche che hanno una tipologia azienda S.p.a, S.a.p.a, S.r.l., S.r.l.s.");
                                    model.set("_customer", null);
                                    model.validate()
                                }
                                model.invalidateForm()
                            }
                            break
                    }


                });
            },
            areas: [
                {
                    component: AreaNoCard,
                    className: "zero-padding",
                    fields: [
                        {
                            property: "addDocumentDialog",
                            control: DossierAddDocumentDialog,
                            emptyRow: true
                        },
                        {
                            property: "refuseDocumentDialog",
                            control: DossierRefuseDocumentDialog,
                            emptyRow: true
                        },
                        {
                            property: "c",
                            control: Column,
                            size: "col-md-8",
                            className: "m-b-10",
                            noLateralPadding: false,
                            fields: [
                                {
                                    property: "c_1",
                                    control: Column,
                                    size: "col-sm-12",
                                    className: "card",
                                    noLateralPadding: false,
                                    fields: [
                                        {
                                            property: "c_1",
                                            control: Column,
                                            size: "col-md-4 col-sm-6",
                                            className: "zero-padding",
                                            noLateralPadding: false,
                                            fields: [
                                                {
                                                    property: "code",
                                                    control: Spacer,
                                                    label: M("dossierEcoBonus"),
                                                    size: "col-sm-12",
                                                    emptyRow: true,
                                                    className: "m-b-10",
                                                    props: {
                                                        className: "ecobonus-code",
                                                        defaultTheme: false,
                                                        formatter: v => {
                                                            return v != null ? v.get("dossierCode") : ""
                                                        }
                                                    },
                                                },
                                            ]
                                        },
                                        {
                                            property: "c_2",
                                            control: Column,
                                            size: "col-md-4 col-sm-6",
                                            className: "zero-padding",
                                            noLateralPadding: false,
                                            fields: [
                                                {
                                                    property: "type",
                                                    control: ReadOnlyText,
                                                    label: M("type"),
                                                    placeholder: M("type"),
                                                    size: "col-sm-12",
                                                    props: {
                                                        formatter: v => {
                                                            return M(v)
                                                        }
                                                    }
                                                },
                                            ]
                                        },
                                        {
                                            property: "c_3",
                                            control: Column,
                                            size: "col-md-4 col-sm-6",
                                            className: "zero-padding",
                                            noLateralPadding: false,
                                            fields: [
                                                {
                                                    property: "creationDate",
                                                    control: ReadOnlyText,
                                                    label: M("creationDate"),
                                                    placeholder: M("creationDate"),
                                                    size: "col-sm-12",
                                                    props: {
                                                        formatter: v => {
                                                            return v != null ? moment(v).format("DD/MM/YYYY HH:mm") : moment(new Date()).format("DD/MM/YYYY HH:mm")
                                                        }
                                                    }
                                                },
                                            ]
                                        },
                                        {
                                            property: "_customer",
                                            label: M("customer"),
                                            getControl: (model) => {
                                                //Il cliente non è modificabile in fase di modifica della pratica oppure in caso di creazione delle pratiche 2020_50 nel quale viene pre-selezionato a monte
                                                let readonly =  model.get("id") !== null;
                                                /*
                                                if (!readonly && model.get("_customer")) {
                                                    readonly = true;
                                                }*/
                                                return readonly? ReadOnlyText: ValuesLookupContainer
                                            },
                                            size: "col-md-4 col-sm-6",
                                            isRequired: true,
                                            props: {
                                                id: "dossier_customer",
                                                mode: "single",
                                                collection: "customers",
                                                selectionGrid: {
                                                    columns: [
                                                        {property: "code", header: M("code"), cell: TextCell},
                                                        {property: "name", header: M("name"), cell: TextCell}
                                                    ]
                                                },
                                                popupGrid: {
                                                    columns: [
                                                        {property: "code", header: M("code"), cell: TextCell},
                                                        {property: "name", header: M("name"), cell: TextCell}
                                                    ]
                                                },
                                                formatter: v => {
                                                    return v != null ? v.name : "";
                                                }
                                            }
                                        },
                                        {
                                            property: "_fabricator",
                                            label: M("fabricator"),
                                            isRequired: true,
                                            getControl: (model) => {
                                                return model.get("id") == null && isSuperuser() ? ValuesLookupContainer : ReadOnlyText
                                            },
                                            size: "col-md-4 col-sm-6",
                                            props: {
                                                id: "dossier_fabricator",
                                                mode: "single",
                                                collection: "fabricators",
                                                selectionGrid: {
                                                    columns: [
                                                        {property: "code", header: M("code"), cell: TextCell},
                                                        {
                                                            property: "businessName",
                                                            header: M("businessName"),
                                                            cell: TextCell
                                                        },
                                                        {
                                                            property: "completedProfile",
                                                            header: M("completedProfile"),
                                                            cell: TextCell,
                                                            props: {
                                                                formatter: v => {
                                                                    return v ? M("yes") : M("no");
                                                                }
                                                            }
                                                        }
                                                    ]
                                                },
                                                popupGrid: {
                                                    columns: [
                                                        {property: "code", header: M("code"), cell: TextCell},
                                                        {
                                                            property: "businessName",
                                                            header: M("businessName"),
                                                            cell: TextCell
                                                        },
                                                        {
                                                            property: "completedProfile",
                                                            header: M("completedProfile"),
                                                            cell: TextCell,
                                                            props: {
                                                                formatter: v => {
                                                                    return v ? M("yes") : M("no");
                                                                }
                                                            }
                                                        }
                                                    ]
                                                },
                                                formatter: v => {
                                                    return v != null ? v.businessName : "";
                                                }
                                            }
                                        },
                                        {
                                            property: "_fabricatorCollaborator",
                                            label: M("collaborator"),
                                            isRequired: true,
                                            getControl: (model) => {
                                                return model.get("id") == null && model.get("_fabricator") != null && isSuperuser() ? ValuesLookupContainer : ReadOnlyText
                                            },
                                            size: "col-md-4 col-sm-6",
                                            props: {
                                                id: "dossier_fabricator_collaborator",
                                                mode: "single",
                                                getCollection: (model) => {
                                                    return "collaborators/" + model.get("_fabricator").id;
                                                },
                                                selectionGrid: {
                                                    columns: [
                                                        {property: "code", header: M("code"), cell: TextCell},
                                                        {property: "name", header: M("name"), cell: TextCell},
                                                        {
                                                            property: "lastname",
                                                            header: M("lastname"),
                                                            cell: TextCell
                                                        },
                                                    ]
                                                },
                                                popupGrid: {
                                                    columns: [
                                                        {property: "code", header: M("code"), cell: TextCell},
                                                        {property: "name", header: M("name"), cell: TextCell},
                                                        {
                                                            property: "lastname",
                                                            header: M("lastname"),
                                                            cell: TextCell
                                                        },
                                                    ]
                                                },
                                                formatter: v => {
                                                    return v != null ? v.lastname + " " + v.name : "";
                                                }
                                            }
                                        },
                                        {
                                            property: "address",
                                            getControl: (model) => {
                                                return model.get("id") == null || model.get("status") === DossierStatus.STATUS_QUOTATION.value ? Text : ReadOnlyText
                                            },
                                            //control: Text,
                                            label: M("buildingAddress"),
                                            placeholder: M("buildingAddress"),
                                            size: "col-sm-4",
                                            isRequired: true,
                                        },
                                        {
                                            property: "city",
                                            getControl: (model) => {
                                                return model.get("id") == null || model.get("status") === DossierStatus.STATUS_QUOTATION.value ? Text : ReadOnlyText
                                            },
                                            //control: Text,
                                            label: M("buildingCity"),
                                            placeholder: M("buildingCity"),
                                            size: "col-sm-4",
                                            isRequired: true,
                                        },
                                        {
                                            property: "province",
                                            getControl: (model) => {
                                                return model.get("id") == null || model.get("status") === DossierStatus.STATUS_QUOTATION.value ? Text : ReadOnlyText
                                            },
                                            //control: Text,
                                            label: M("buildingProvince"),
                                            placeholder: M("province"),
                                            size: "col-sm-4",
                                            isRequired: true,
                                        },


                                        valuesSelectContainerField({
                                            property: "quotationType",
                                            isRequired: true,
                                            collection: "dossierBonusCasa2QuotationType",
                                            itemValue: "value",
                                            itemLabel: "label",
                                            size: "col-sm-12",
                                            params: {
                                                firstLoadTimeout: 500
                                            },
                                            getControl: (model) => {
                                                return model && model.get("id") == null || model.get("status") === DossierStatus.STATUS_QUOTATION.value? ValuesSelectContainer : ReadOnlyText
                                            },
                                            formatter(v, model) {
                                                return  v && model.get("quotationTypeDescription") ? model.get("quotationTypeDescription") : "-"
                                            }
                                        }),

                                        valuesSelectContainerField({
                                            property: "estateTypeAndUse",
                                            isRequired: true,
                                            itemLabel: "label",
                                            itemValue: "value",
                                            collection: "estateTypeAndUse",
                                            size: "col-sm-6",
                                            getControl: (model) => {
                                                return model.get("id") == null || model.get("status") === DossierStatus.STATUS_QUOTATION.value ? ValuesSelectContainer : ReadOnlyText
                                            },
                                            formatter(v, model) {
                                                if (model && model.get("id") != null)
                                                    return model.get("priceCalculatorSheet").estateTypeAndUseDescription
                                                return  v != null ? v["fullDescription"] : ""
                                            }
                                        }),

                                        valuesSelectContainerField({
                                            property: "isDelimitingHeatedWithNotHeated",
                                            isRequired: true,
                                            itemLabel: "label",
                                            itemValue: "value",
                                            collection: "delimitingHeatedWithNotHeatedTypes",
                                            size: "col-sm-6",
                                            getControl: (model) => {

                                                return model.get("id") == null || model.get("status") === DossierStatus.STATUS_QUOTATION.value ? ValuesSelectContainer : ReadOnlyText
                                            },
                                            formatter(v, model) {
                                                return  v != null ? M(v) : ""
                                            }
                                        }),

                                        valuesSelectContainerField({
                                            property: "blindsPresentsType",
                                            isRequired: true,
                                            itemLabel: "label",
                                            itemValue: "value",
                                            collection: "blindsPresentsType",
                                            size: "col-sm-6",
                                            getControl: (model) => {
                                                if (QUOTATION_TYPES_BONUSCASA_2022_2_ONLY_BLIND.indexOf(model.get("quotationType")) !== -1)
                                                    return ReadOnlyText

                                                return model && (model.get("id") == null || model.get("status") === DossierStatus.STATUS_QUOTATION.value) ? ValuesSelectContainer : ReadOnlyText
                                            },
                                            formatter(v, model) {
                                                if (model && model.get("id") != null)
                                                    return getBlindsPresentsValueDescription(model.get("priceCalculatorSheet").blindsPresentsType)
                                                return  v != null ? getBlindsPresentsValueDescription(v) : ""
                                            }
                                        }),

                                        valuesSelectContainerField({
                                            property: "climaticZone",
                                            isRequired: true,
                                            itemLabel: "label",
                                            itemValue: "value",
                                            collection: "climaticZones",
                                            size: "col-sm-6",
                                            getControl: (model) => {
                                                let readonlyComponent = ReadOnlyText;
                                                if (!model)
                                                    return readonlyComponent
                                                return model.get("id") == null || model.get("status") === DossierStatus.STATUS_QUOTATION.value ? ValuesSelectContainer : ReadOnlyText
                                            },
                                            formatter(v, model) {
                                                if (model && model.get("id") != null)
                                                    return model.get("priceCalculatorSheet").climaticZone
                                                return  v != null ? v["label"] : ""
                                            }
                                        }),

                                        {
                                            property: "c_blind",
                                            control: Column,
                                            emptyRow: true,
                                            visibility: (model) => quotationSurfaceSizeVisibility(model),
                                            size: "col-sm-6",
                                            noLateralPadding: true,
                                            props: {
                                                setStyle: false
                                            },
                                            fields: [
                                                {
                                                    property: "spacer_blind",
                                                    control: Spacer,
                                                    label: null,
                                                    size: "col-sm-12",
                                                    emptyRow: true,
                                                    className: "m-b-10",
                                                    props: {
                                                        className: "blind-title",
                                                        defaultTheme: false,
                                                        formatter: model => {
                                                            return QUOTATION_TYPES_BONUSCASA_2022_2_ONLY_BLIND.indexOf(model.get("quotationType")) === -1 ? "Fornitura infissi con oscuranti" : "Fornitura persiane";
                                                        }
                                                    },
                                                },

                                                {
                                                    property: "notPermittedAmount",
                                                    required: false,
                                                    control: OnlyTextInfo,
                                                    getLabel(model) {
                                                        if (model) {
                                                            let priceCalculatorSheet = model.get("priceCalculatorSheet")
                                                            return priceCalculatorSheet && priceCalculatorSheet.maxSizeValueDescription ? priceCalculatorSheet.maxSizeValueDescription : "Limite spesa massima agevolabile : - "
                                                        }

                                                        return "";
                                                    },
                                                    size: "col-sm-12",
                                                    props: {
                                                        showIcon: false,
                                                        getClassName(model) {
                                                            if (model) {
                                                                let priceCalculatorSheet = optional(model.get("priceCalculatorSheet"), {})

                                                                let totalNotPermitted = priceCalculatorSheet.blindsPresentsType === BlindsPresentsValues.BOTH.value ? priceCalculatorSheet.totalNotPermittedWithBlind : priceCalculatorSheet.totalNotPermitted;

                                                                if (totalNotPermitted > 0)
                                                                    return "notPermittedAmount-label";
                                                                else
                                                                    return "allPermittedAmount-label";

                                                                return "notPermittedAmount-label"
                                                            }

                                                            return null;
                                                        },
                                                        formatter(v, model) {
                                                            if (model) {
                                                                let priceCalculatorSheet = model.get("priceCalculatorSheet")
                                                                return priceCalculatorSheet?  priceCalculatorSheet.notPermittedAmountDescription: "-"
                                                            }

                                                            return "";

                                                        }
                                                    }
                                                },

                                            ]
                                        },

                                        {
                                            property: "surfaceSize",
                                            getControl: (model) => {
                                                return model && (model.get("id") == null || model.get("status") === DossierStatus.STATUS_QUOTATION.value) ? Number : ReadOnlyText
                                            },
                                            label: M("surfaceSizeMq"),
                                            placeholder: M("surfaceSizeMq"),
                                            size: "col-sm-6",
                                            visibility: (model) => quotationSurfaceSizeVisibility(model),
                                            isRequired: true,
                                            props: {
                                                formatter(v, model) {
                                                    let value = v
                                                    if (model && model.get("id") != null)
                                                        value = model.get("priceCalculatorSheet").surfaceSize
                                                    return formatNumber(value);
                                                }
                                            }
                                        },

                                        {
                                            property: "window",
                                            getControl: (model) => {
                                                let readonlyComponent = ReadOnlyText;
                                                if (!model)
                                                    return readonlyComponent
                                                return model.get("id") == null || model.get("status") === DossierStatus.STATUS_QUOTATION.value ? Number : readonlyComponent
                                            },
                                            visibility: (model) => quotationFieldsVisibility(model),
                                            getLabel: (model) => {
                                                return model != null && model.get("priceCalculatorSheet") != null ? model.get("priceCalculatorSheet").windowLabel : "Infissi (€)";
                                            },
                                            getPlaceholder: (model) => {
                                                return model != null && model.get("priceCalculatorSheet") != null ? model.get("priceCalculatorSheet").windowLabel : "Infissi (€)";
                                            },
                                            //label: "Infissi - Bene Significativo (€)",
                                            //placeholder: "Infissi - Bene Significativo (€)",
                                            size: "col-sm-6",
                                            isRequired: false,
                                            props: {
                                                formatter: v => {
                                                    return formatNumber(v)
                                                }
                                            }
                                        },

                                        {
                                            property: "blind",
                                            getControl: (model) => {
                                                let readonlyComponent = ReadOnlyText;
                                                if (!model)
                                                    return readonlyComponent
                                                return model.get("id") == null || model.get("status") === DossierStatus.STATUS_QUOTATION.value ? Number : readonlyComponent
                                            },
                                            visibility: (model) => quotationFieldsVisibility(model),
                                            getLabel: (model) => {
                                                if(model != null && model.get("priceCalculatorSheet") != null && QUOTATION_TYPES_BONUSCASA_2022_2_ONLY_BLIND.indexOf(model.get("quotationType")) !== -1) {
                                                    return "Beni NS, Mark-Up (€)";
                                                } else {
                                                    return "Oscuranti, Beni NS, Mark-Up (€)";
                                                }
                                            },
                                            getPlaceholder: (model) => {
                                                if(model != null && model.get("priceCalculatorSheet") != null && QUOTATION_TYPES_BONUSCASA_2022_2_ONLY_BLIND.indexOf(model.get("quotationType")) !== -1) {
                                                    return "Beni NS, Mark-Up (€)";
                                                } else {
                                                    return "Oscuranti, Beni NS, Mark-Up (€)";
                                                }
                                            },
                                            size: "col-sm-6",
                                            props: {
                                                formatter: v => {
                                                    return formatNumber(v)
                                                }
                                            }
                                        },

                                        {
                                            property: "otherWorks",
                                            getControl: (model) => {
                                                let readonlyComponent = ReadOnlyText;
                                                if (!model)
                                                    return readonlyComponent
                                                return model.get("id") == null || model.get("status") === DossierStatus.STATUS_QUOTATION.value ? Number : readonlyComponent
                                            },
                                            visibility: (model) => quotationFieldsVisibility(model) && QUOTATION_TYPES_BONUSCASA_2022_2_ONLY_SUPPLY.indexOf(model.get("quotationType")) === -1,
                                            label: "Posa e Installazione",
                                            placeholder: "Posa e Installazione",
                                            size: "col-sm-6",
                                            isRequired: true,
                                            props: {
                                                formatter: v => {
                                                    return formatNumber(v)
                                                }
                                            }
                                        },

                                        {
                                            property: "takenMeasures",
                                            getControl: (model) => {
                                                let readonlyComponent = ReadOnlyText;
                                                if (!model)
                                                    return readonlyComponent
                                                return model.get("id") == null || model.get("status") === DossierStatus.STATUS_QUOTATION.value ? Number : readonlyComponent
                                            },
                                            visibility: (model) => quotationFieldsVisibility(model),
                                            label: "Eventuali Altre Spese professionali da ivare al 22%",
                                            placeholder: "Eventuali Altre Spese professionali da ivare al 22%",
                                            size: "col-sm-6",
                                            isRequired: false,
                                            props: {
                                                formatter: v => {
                                                    return formatNumber(v)
                                                }
                                            }
                                        },
                                        //
                                        // {
                                        //     property: "spacer_blind",
                                        //     control: Spacer,
                                        //     size: "col-sm-12",
                                        //     emptyRow: true,
                                        //     className: "m-b-10 m-t-10",
                                        //     props: {
                                        //         defaultTheme: false,
                                        //     },
                                        // },

                                        {
                                            property: "c_without_blind",
                                            control: Column,
                                            size: "col-sm-6",
                                            emptyRow: true,
                                            visibility: (model) => quotationSurfaceSizeVisibility(model, false),
                                            noLateralPadding: true,
                                            props: {
                                                setStyle: false
                                            },
                                            fields: [
                                                {
                                                    property: "spacer_without_blind",
                                                    control: Spacer,
                                                    label: null,
                                                    size: "col-sm-12",
                                                    emptyRow: true,
                                                    className: "m-b-10",
                                                    props: {
                                                        className: "blind-title",
                                                        defaultTheme: false,
                                                        formatter: model => {
                                                            return QUOTATION_TYPES_ONLY_BLIND.indexOf(model.get("quotationType")) === -1 ? "Fornitura infissi senza oscuranti" : "Fornitura Persiane";
                                                        }
                                                    },
                                                },

                                                {
                                                    property: "notPermittedAmountWithoutBlind",
                                                    required: false,
                                                    control: OnlyTextInfo,
                                                    getLabel(model) {
                                                        if (model) {
                                                            let priceCalculatorSheet = model.get("priceCalculatorSheet")
                                                            return priceCalculatorSheet && priceCalculatorSheet.maxSizeValueWithoutBlindDescription ? priceCalculatorSheet.maxSizeValueWithoutBlindDescription : "Limite spesa massima agevolabile : - "
                                                        }

                                                        return "";
                                                    },
                                                    size: "col-sm-12",
                                                    props: {
                                                        showIcon: false,
                                                        getClassName(model) {
                                                            if (model) {
                                                                let priceCalculatorSheet = model.get("priceCalculatorSheet")

                                                                if (priceCalculatorSheet.totalNotPermittedWithoutBlind > 0)
                                                                    return "notPermittedAmount-label";
                                                                else
                                                                    return "allPermittedAmount-label";
                                                            }

                                                            return null;
                                                        },
                                                        formatter(v, model) {
                                                            if (model) {
                                                                let priceCalculatorSheet = model.get("priceCalculatorSheet")
                                                                return priceCalculatorSheet?  priceCalculatorSheet.notPermittedAmountWithoutBlindDescription : "-"
                                                            }

                                                            return "";

                                                        }
                                                    }
                                                },

                                            ]
                                        },

                                        {
                                            property: "surfaceSizeWithoutBlind",
                                            getControl: (model) => {
                                                let readonlyComponent = ReadOnlyText;
                                                if (!model)
                                                    return readonlyComponent
                                                return model.get("id") == null || model.get("status") === DossierStatus.STATUS_QUOTATION.value ? Number : readonlyComponent
                                            },
                                            visibility: (model) => quotationSurfaceSizeVisibility(model, false),
                                            label: M("surfaceSizeMq"),
                                            placeholder: M("surfaceSizeMq"),
                                            size: "col-sm-6",
                                            isRequired: true,
                                            props: {
                                                formatter(v, model) {
                                                    let value = v
                                                    if (model && model.get("id") != null)
                                                        value = model.get("priceCalculatorSheet").surfaceSizeWithoutBlind
                                                    return formatNumber(value);
                                                }
                                            }
                                        },

                                        {
                                            property: "windowWithoutBlind",
                                            getControl: (model) => {
                                                let readonlyComponent = ReadOnlyText;
                                                if (!model)
                                                    return readonlyComponent
                                                return model.get("id") == null || model.get("status") === DossierStatus.STATUS_QUOTATION.value ? Number : readonlyComponent
                                            },
                                            visibility: (model) => quotationFieldsVisibility(model, false),
                                            label: "Infissi - Bene Significativo (€)",
                                            placeholder: "Infissi - Bene Significativo (€)",
                                            size: "col-sm-6",
                                            isRequired: true,
                                            props: {
                                                formatter: v => {
                                                    return formatNumber(v)
                                                }
                                            }
                                        },

                                        {
                                            property: "blindWithoutBlind",
                                            getControl: (model) => {
                                                let readonlyComponent = ReadOnlyText;
                                                if (!model)
                                                    return readonlyComponent
                                                return model.get("id") == null || model.get("status") === DossierStatus.STATUS_QUOTATION.value ? Number : readonlyComponent
                                            },
                                            visibility: (model) => quotationFieldsVisibility(model, false),
                                            label: "Beni NS, Mark-Up",
                                            placeholder: "Beni NS, Mark-Up",
                                            size: "col-sm-6",
                                            props: {
                                                formatter: v => {
                                                    return formatNumber(v)
                                                }
                                            }
                                        },

                                        {
                                            property: "otherWorksWithoutBlind",
                                            getControl: (model) => {
                                                let readonlyComponent = ReadOnlyText;
                                                if (!model)
                                                    return readonlyComponent
                                                return model.get("id") == null || model.get("status") === DossierStatus.STATUS_QUOTATION.value ? Number : readonlyComponent
                                            },
                                            visibility: (model) => quotationFieldsVisibility(model, false) && QUOTATION_TYPES_BONUSCASA_2022_2_ONLY_SUPPLY.indexOf(model.get("quotationType")) === -1,
                                            label: "Posa e Installazione",
                                            placeholder: "Posa e Installazione",
                                            // placeholder: "Altre Opere e Servizi Complementari all'Installazione e alla Posa",
                                            size: "col-sm-6",
                                            isRequired: true,
                                            props: {
                                                formatter: v => {
                                                    return formatNumber(v)
                                                }
                                            }
                                        },

                                        {
                                            property: "takenMeasuresWithoutBlind",
                                            getControl: (model) => {
                                                let readonlyComponent = ReadOnlyText;
                                                if (!model)
                                                    return readonlyComponent
                                                return model.get("id") == null || model.get("status") === DossierStatus.STATUS_QUOTATION.value ? Number : readonlyComponent
                                            },
                                            visibility: (model) => quotationFieldsVisibility(model, false),
                                            label: "Eventuali Altre Spese professionali da ivare al 22%",
                                            placeholder: "Eventuali Altre Spese professionali da ivare al 22%",
                                            size: "col-sm-6",
                                            props: {
                                                formatter: v => {
                                                    return formatNumber(v)
                                                }
                                            }
                                        },

                                        // {
                                        //     property: "spacer_blind",
                                        //     control: Spacer,
                                        //     size: "col-sm-12",
                                        //     emptyRow: true,
                                        //     className: "m-b-10 m-t-10",
                                        //     props: {
                                        //         defaultTheme: false,
                                        //     },
                                        // },

                                        {
                                            property: "buildingTitleOpeningDate",
                                            getControl: (model) => {
                                                let readonlyComponent = ReadOnlyText;
                                                if (!model)
                                                    return readonlyComponent
                                                return model.get("id") == null || model.get("status") === DossierStatus.STATUS_QUOTATION.value ? DateTime : readonlyComponent
                                            },
                                            label: M("buildingTitleOpeningDate"),
                                            placeholder: M("buildingTitleOpeningDate"),
                                            size: "col-sm-6",
                                            props: {
                                                formatter: v => {
                                                    return v != null ? moment(v).format("DD/MM/YYYY") : "-";
                                                },
                                                getMinDate: (model) => {
                                                    return "15.04.2022";
                                                }
                                            }
                                        },
                                        {
                                            property: "workCompletionDate",
                                            getControl: (model) => {
                                                let workCompletionDocuments = _.filter(model.get("documents"), r => WORK_COMPLETION_DOCUMENTS_CODE.includes(r.documentType.code));
                                                return model.get("workCompletionDate") == null || (getDossierStatusPosition(model.get("status")) <= getDossierStatusPosition(DossierStatus.STATUS_TO_CANDIDATE) || (workCompletionDocuments.length > 0 && (workCompletionDocuments[0].status === DocumentStatus.TO_BE_UPLOAD.value || workCompletionDocuments[0].status === DocumentStatus.TO_RECHARGE.value))) ? DateTime : ReadOnlyText;
                                             },
                                            control: DateTime,
                                            label: M("workCompletionDate"),
                                            placeholder: M("workCompletionDate"),
                                            size: "col-sm-6",
                                            visibility: (model) => {
                                                return model.get("id")
                                            },
                                            props: {
                                                formatter: v => {
                                                    return v != null ? moment(v).format("DD/MM/YYYY") : "-";
                                                }
                                            }
                                        },
                                        {
                                            property: "totalCostHigherTenThousand",
                                            control: YesNo,
                                            label: M("totalCostHigherTenThousand"),
                                            size: "col-sm-6",
                                            isRequired: true,
                                            props: {
                                                formatter(v, model) {
                                                    if (v != null)
                                                        return v === true ? "Si" : "No"
                                                    return ""
                                                }
                                            }
                                        },
                                        {
                                            property: "acceptServiceCosts",
                                            getControl: (model) => {
                                                return (model.get("id") === null || model.get("status") === DossierStatus.STATUS_QUOTATION.value) ? YesNo : ReadOnlyText
                                            },
                                            label: "Accetta i costi del servizio",
                                            size: "col-sm-6",
                                            isRequired: true,
                                            props: {
                                                formatter(v, model) {
                                                    return "Accettati"
                                                }
                                            }
                                        },
                                        {
                                            property: "notes",
                                            getControl: model => {
                                                return model.get("id") != null ? TextArea : Text;
                                            },
                                            visibility: (model) => {
                                                return isSuperuser() && model.get("id")
                                            },
                                            label: M("notes"),
                                            placeholder: M("notes"),
                                            size: "col-sm-12",
                                            emptyRow: true,
                                            props: {
                                                maxLength: 1000,
                                                height: "60px"
                                            }
                                        },
                                        {
                                            property: "fabricatorNotes",
                                            getControl: model => {
                                                return model.get("id") != null ? TextArea : Text;
                                            },

                                            label: M("fabricatorNotes"),
                                            placeholder: M("fabricatorNotes"),
                                            size: "col-sm-12",
                                            emptyRow: true,
                                            props: {
                                                maxLength: 1000,
                                                height: "60px"
                                            }
                                        },

                                        {
                                            property: "c_b_1",
                                            control: Column,
                                            size: "col-md-4 col-sm-6",
                                            visibility: (model) => {
                                                return isSuperuser() && model != null && model.get("id") != null && model.get("status") !== DossierStatus.STATUS_QUOTATION.value;
                                            },
                                            noLateralPadding: false,
                                            fields: [
                                                {
                                                    property: "c_b_1_s",
                                                    control: Column,
                                                    size: "col-md-12",
                                                    className: "zero-padding border-bottom m-b-15",
                                                    noLateralPadding: false,
                                                    fields: [
                                                        {
                                                            control: Spacer,
                                                            label: null,
                                                            size: "col-8",
                                                            emptyRow: true,
                                                            props: {
                                                                className: "p-t-9",
                                                                defaultTheme: false,
                                                                content: M("canBeCandidate")
                                                            },
                                                        },
                                                        {
                                                            control: Spacer,
                                                            label: null,
                                                            size: "col-4",
                                                            emptyRow: true,
                                                            props: {
                                                                className: "p-t-9 float-right",
                                                                defaultTheme: false,
                                                                formatter: model => {
                                                                    return model.get("canBeCandidate") ? M("yes") : M("no")
                                                                }
                                                            },
                                                        },
                                                    ]
                                                },
                                            ]
                                        },
                                        {
                                            property: "c_b_2",
                                            control: Column,
                                            size: "col-md-4 col-sm-6",
                                            visibility: (model) => {
                                                return isSuperuser() && model != null && model.get("id") != null && model.get("status") !== DossierStatus.STATUS_QUOTATION.value;
                                            },
                                            noLateralPadding: false,
                                            fields: [
                                                {
                                                    property: "c_b_2_s",
                                                    control: Column,
                                                    size: "col-md-12",
                                                    className: "zero-padding border-bottom m-b-15",
                                                    noLateralPadding: false,
                                                    fields: [
                                                        {
                                                            control: Spacer,
                                                            label: null,
                                                            size: "col-8",
                                                            emptyRow: true,
                                                            props: {
                                                                className: "p-t-7",
                                                                defaultTheme: false,
                                                                content: M("candidateAE")
                                                            },
                                                        },
                                                        {
                                                            property: "candidateAE",
                                                            control: Switch,
                                                            label: null,
                                                            size: "col-4",
                                                            emptyRow: true,
                                                        },
                                                    ]
                                                },
                                            ]
                                        },
                                        {
                                            property: "c_b_3",
                                            control: Column,
                                            size: "col-md-4 col-sm-6",
                                            visibility: (model) => {
                                                return isSuperuser() && model != null && model.get("id") != null && model.get("status") !== DossierStatus.STATUS_QUOTATION.value;
                                            },
                                            noLateralPadding: false,
                                            fields: [
                                                {
                                                    property: "c_b_3_s",
                                                    control: Column,
                                                    size: "col-md-12",
                                                    className: "zero-padding border-bottom m-b-15",
                                                    noLateralPadding: false,
                                                    fields: [
                                                        {
                                                            control: Spacer,
                                                            label: null,
                                                            size: "col-8",
                                                            emptyRow: true,
                                                            props: {
                                                                className: "p-t-7",
                                                                defaultTheme: false,
                                                                content: M("candidateENEA")
                                                            },
                                                        },
                                                        {
                                                            property: "candidateENEA",
                                                            control: Switch,
                                                            label: null,
                                                            size: "col-4",
                                                            emptyRow: true,
                                                        },
                                                    ]
                                                },

                                            ]
                                        },
                                        {
                                            property: "c_b_3",
                                            control: Column,
                                            size: "col-md-4 col-sm-6",
                                            visibility: (model) => {
                                                return isSuperuser() && model != null && model.get("id") != null && model.get("status") !== DossierStatus.STATUS_QUOTATION.value;
                                            },
                                            noLateralPadding: false,
                                            fields: [
                                                {
                                                    property: "c_b_3_s",
                                                    control: Column,
                                                    size: "col-md-12",
                                                    className: "zero-padding border-bottom m-b-15",
                                                    noLateralPadding: false,
                                                    fields: [
                                                        {
                                                            control: Spacer,
                                                            label: null,
                                                            size: "col-8",
                                                            emptyRow: true,
                                                            props: {
                                                                className: "p-t-7",
                                                                defaultTheme: false,
                                                                content: M("communicationENEA")
                                                            },
                                                        },
                                                        {
                                                            property: "communicationENEA",
                                                            control: Switch,
                                                            label: null,
                                                            size: "col-4",
                                                            emptyRow: true,
                                                        },
                                                    ]
                                                },
                                            ]
                                        },
                                        {
                                            property: "c_b_4",
                                            control: Column,
                                            size: "col-md-4 col-sm-6",
                                            visibility: (model) => {
                                                return isSuperuser() && model != null && model.get("id") != null;
                                            },
                                            noLateralPadding: false,
                                            fields: [
                                                {
                                                    property: "c_b_4_s",
                                                    control: Column,
                                                    size: "col-md-12",
                                                    className: "zero-padding border-bottom m-b-15",
                                                    noLateralPadding: false,
                                                    fields: [
                                                        {
                                                            control: Spacer,
                                                            label: null,
                                                            size: "col-8",
                                                            emptyRow: true,
                                                            props: {
                                                                className: "p-t-7",
                                                                defaultTheme: false,
                                                                content: M("priority")
                                                            },
                                                        },
                                                        {
                                                            property: "priority",
                                                            control: Switch,
                                                            label: null,
                                                            size: "col-4",
                                                            emptyRow: true,
                                                        },
                                                    ]
                                                },
                                            ]
                                        },
                                    ]
                                },
                            ]
                        },
                        {
                            property: "column",
                            control: Dossier_2022_bonusCasa_2_priceCalculatorControl,
                            size: "col-md-4 col-sm-6",
                            className: "m-b-10",
                            noLateralPadding: false,
                            useBoostrapRow: true
                        },
                        {
                            property: "c_",
                            control: Column,
                            size: "col-md-8",
                            className: "m-b-10",
                            emptyRow: true,
                            noLateralPadding: false,
                            fields: [
                                {
                                    property: "c_1",
                                    control: Column,
                                    size: "col-sm-12",
                                    className: "card",
                                    noLateralPadding: false,
                                    visibility: (model) => {
                                        return isSuperuser() && model != null && model.get("id") != null && model.get("status") !== DossierStatus.STATUS_QUOTATION.value;
                                    },
                                    fields: [
                                        {
                                            property: "code",
                                            control: Spacer,
                                            label: null,
                                            size: "col-sm-12",
                                            emptyRow: true,
                                            props: {
                                                className: "card-title",
                                                defaultTheme: false,
                                                content: M("kpmgStatus"),
                                            },
                                        },
                                        {
                                            property: "kpmgdocumentGroupsStatus",
                                            control: MultiLineText,
                                            label: null,
                                            size: "col-sm-8",
                                            emptyRow: true,
                                            className: "m-b-10",
                                            props: {
                                                defaultTheme: false,
                                                innerClass: "m-b-5"
                                            },
                                        },
                                        {
                                            property: "_sendForReview",
                                            control: Button,
                                            size: "col-sm-4",
                                            emptyRow: true,
                                            visibility: (model) => {
                                                return isSuperuser() && model != null && model.get("id") != null
                                                    // && model.get("kpmgdossierReviewCompletionDate") == null;
                                            },
                                            props: {
                                                text: M("sendToKPMG"),
                                                className: "btn-orange",
                                                onClick: model => {
                                                    KPMGSendForReview({
                                                        dossierId: model.get("id"),
                                                        dossierType: model.get("type")
                                                    })
                                                }
                                            }
                                        },
                                        {
                                            property: "_kpmgLog",
                                            control: ReadOnlyTextArea,
                                            visibility: (model) => {
                                                return isSuperuser() && model != null && model.get("id") != null;
                                            },
                                            label: "Stato ultimo invio a KPMG",
                                            placeholder: "-",
                                            size: "col-sm-12",
                                            props: {
                                                autoHeight: true

                                            }
                                        },
                                        {
                                            property: "code",
                                            control: Spacer,
                                            label: null,
                                            size: "col-sm-12",
                                            emptyRow: true,
                                            visibility: (model) => {
                                                return isSuperuser() && model != null && model.get("id") != null && model.get("kpmgdossierReviewCompletionDate") != null;
                                            },
                                            props: {
                                                defaultTheme: false,
                                                showBorderBottom: true
                                            },
                                        },
                                        {
                                            property: "kpmgdossierReviewCompletionDate",
                                            control: ReadOnlyText,
                                            visibility: (model) => {
                                                return isSuperuser() && model != null && model.get("id") != null && model.get("kpmgdossierReviewCompletionDate") != null;
                                            },
                                            label: "Data di fine revisione KPMG",
                                            placeholder: "Data di fine revisione KPMG",
                                            size: "col-sm-4",
                                            props: {
                                                formatter: v => {
                                                    return v != null ? moment(v).format("DD/MM/YYYY HH:mm") : moment(new Date()).format("DD/MM/YYYY HH:mm")
                                                }
                                            }
                                        },
                                        {
                                            property: "kpmgdossierAdEProtocolNumber",
                                            control: ReadOnlyText,
                                            visibility: (model) => {
                                                return isSuperuser() && model != null && model.get("id") != null && model.get("kpmgdossierAdEProtocolNumber") != null;
                                            },
                                            label: "N. Protocollo Agenzia delle Entrate",
                                            placeholder: "N. Protocollo Agenzia delle Entrate",
                                            size: "col-sm-4",
                                        },
                                        {
                                            property: "kpmgadeDossierAmount",
                                            control: ReadOnlyText,
                                            visibility: (model) => {
                                                return isSuperuser() && model != null && model.get("id") != null && model.get("kpmgadeDossierAmount") != 0;
                                            },
                                            label: "Ammontare della pratica",
                                            placeholder: "Ammontare della pratica",
                                            size: "col-sm-4",
                                            props: {
                                                formatter: v => {
                                                    return formatNumber(v)
                                                }
                                            }
                                        },
                                    ]
                                }
                            ]
                        }
                    ]
                },


                //FOOTER
                {
                    component: AreaNoCard,
                    className: "zero-padding m-t-10",
                    fields: [
                        {
                            property: "custom_footer",
                            control: Dossier_2022_BonusCasa_2_FormFooter,
                        }
                    ]
                },
                {
                    component: AreaNoCard,
                    className: "zero-padding",
                    visibility: model => {
                        return model.get("id") != null && model.get("status") !== DossierStatus.STATUS_QUOTATION.value;
                    },
                    fields: [
                        {
                            property: "documents",
                            control: DossierDocumentContainer,
                            label: null,
                            size: "col-sm-12",
                        }
                    ]
                },
            ]
        }
    }
}
